import { formatDate, IconDownload, IconLoader, PermissionEnum } from '@ui/src';
import getAgreementTypeName from '../../../../../hoc/new-application/helpers/get-agreement-type-name';
import { ApplicationAgreement } from '../../../../../hoc/new-application/types';

import cn from '../styles.module.css';

const formatAgreementsList = (
  list: ApplicationAgreement[],
  getAgreementFile: (data: string) => void,
  downloadFile?: string,
  fileDownloadInProgress?: boolean,
  activePermissions?: PermissionEnum[],
): ApplicationAgreement[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const render: Record<string, React.JSX.Element> = {
      type: <div>{getAgreementTypeName(result.type)}</div>,
      startAt: (
        <div className={cn.dateOfSigning}>
          <div>
            {result.signatures?.edges[0]?.node?.signedAt
              ? formatDate(result.signatures.edges[0].node.signedAt)
              : '-'}
          </div>
          {activePermissions?.includes(PermissionEnum.AGREEMENTS_LIST) && (
            <button
              type="button"
              aria-label="Download agreement button"
              className={cn.downloadButton}
              onClick={() => getAgreementFile(result.id)}
              disabled={fileDownloadInProgress && result.id === downloadFile}
            >
              {fileDownloadInProgress && result.id === downloadFile ? (
                <IconLoader width={16} height={16} />
              ) : (
                <IconDownload />
              )}
            </button>
          )}
        </div>
      ),
    };

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatAgreementsList;
